import type { ITemplateConfig } from '~/types/template'

import { pickerPaywallPage4a } from './pages/picker-paywall-4-a'
import { pickerPaywallPage4b } from './pages/picker-paywall-4-b'

import {
  OnBoardingLandscapeTemplate,
  OnBoardingPortraitTemplate,
} from '~/components/DynamicScreen/Templates/OnBoarding'
import { PickerPortraitTemplate } from '~/components/DynamicScreen/Templates/Picker'
import { embeddedPage1, embeddedPage2, embeddedPage3 } from '~/const/template-config/pages/embedded'
import { marketingPage1, marketingPage1Video } from '~/const/template-config/pages/marketing-1'
import { marketingPage2, marketingPage2Video } from '~/const/template-config/pages/marketing-2'
import { marketingPage3, marketingPage3Video } from '~/const/template-config/pages/marketing-3'
import { paywallPage4a, paywallPage4aVideo } from '~/const/template-config/pages/paywall-4-a'
import { paywallPage4b, paywallPage4bVideo } from '~/const/template-config/pages/paywall-4-b'

export const onBoardingPortraitTemplates: Record<string, ITemplateConfig> = {
  onboarding_toggleft_activated_img_4_arg_0_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_0_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_img_4_arg_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_img_4_arg_2_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, marketingPage2, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_2_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_img_4_arg_3_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, marketingPage2, marketingPage3, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_3_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_img_4_arg_embedded_ui_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_embedded_ui_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_video_4_arg_0_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_0_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_video_4_arg_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_video_4_arg_2_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, marketingPage2Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_2_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_activated_video_4_arg_3_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, marketingPage2Video, marketingPage3Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_3_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_img_4_arg_0_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_0_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_img_4_arg_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_img_4_arg_2_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, marketingPage2, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_2_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_img_4_arg_3_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1, marketingPage2, marketingPage3, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_3_market_slides_paywall_portrait', 'tios3_toggle_check'],
    orientation: 'portrait',
  },
  onboarding_toggleft_img_4_arg_embedded_ui_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_embedded_ui_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_video_4_arg_0_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_0_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_video_4_arg_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_video_4_arg_2_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, marketingPage2Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_2_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_video_4_arg_3_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [marketingPage1Video, marketingPage2Video, marketingPage3Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_3_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
  onboarding_toggleft_video_4_arg_embedded_ui_1_market_slides_paywall_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_embedded_ui_1_market_slides_paywall_portrait'],
    orientation: 'portrait',
  },
}

export const onBoardingLandscapeTemplates: Record<string, ITemplateConfig> = {
  onboarding_toggleft_activated_img_4_arg_0_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_0_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_img_4_arg_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_img_4_arg_2_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, marketingPage2, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_2_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_img_4_arg_3_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, marketingPage2, marketingPage3, paywallPage4b, paywallPage4a],
    keys: ['onboarding_toggleft_activated_img_4_arg_3_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_video_4_arg_0_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_0_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_video_4_arg_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_video_4_arg_2_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, marketingPage2Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_2_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_activated_video_4_arg_3_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, marketingPage2Video, marketingPage3Video, paywallPage4bVideo, paywallPage4aVideo],
    keys: ['onboarding_toggleft_activated_video_4_arg_3_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_img_4_arg_0_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_0_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_img_4_arg_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_img_4_arg_2_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, marketingPage2, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_2_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_img_4_arg_3_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1, marketingPage2, marketingPage3, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_3_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_img_4_arg_embedded_ui_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [embeddedPage1, paywallPage4a, paywallPage4b],
    keys: ['onboarding_toggleft_img_4_arg_embedded_ui_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_video_4_arg_0_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_0_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_video_4_arg_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_video_4_arg_2_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, marketingPage2Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_2_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_video_4_arg_3_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [marketingPage1Video, marketingPage2Video, marketingPage3Video, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_3_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
  onboarding_toggleft_video_4_arg_embedded_ui_1_market_slides_paywall_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [embeddedPage1, paywallPage4aVideo, paywallPage4bVideo],
    keys: ['onboarding_toggleft_video_4_arg_embedded_ui_1_market_slides_paywall_landscape'],
    orientation: 'landscape',
  },
}

export const storePortraitTemplates: Record<string, ITemplateConfig> = {
  store_toggleft_activated_img_4_arg_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4b, paywallPage4a],
    keys: ['store_toggleft_activated_img_4_arg_portrait'],
    orientation: 'portrait',
  },
  store_toggleft_activated_video_4_arg_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4bVideo, paywallPage4aVideo],
    keys: ['store_toggleft_activated_video_4_arg_portrait'],
    orientation: 'portrait',
  },
  store_toggleft_img_4_arg_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4a, paywallPage4b],
    keys: ['store_toggleft_img_4_arg_portrait'],
    orientation: 'portrait',
  },
  store_toggleft_video_4_arg_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [paywallPage4aVideo, paywallPage4bVideo],
    keys: ['store_toggleft_video_4_arg_portrait'],
    orientation: 'portrait',
  },
}

export const storeLandscapeTemplates: Record<string, ITemplateConfig> = {
  store_toggleft_activated_img_4_arg_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4b, paywallPage4a],
    keys: ['store_toggleft_activated_img_4_arg_landscape'],
    orientation: 'landscape',
  },
  store_toggleft_activated_video_4_arg_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4bVideo, paywallPage4aVideo],
    keys: ['store_toggleft_activated_video_4_arg_landscape'],
    orientation: 'landscape',
  },
  store_toggleft_img_4_arg_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4a, paywallPage4b],
    keys: ['store_toggleft_img_4_arg_landscape'],
    orientation: 'landscape',
  },
  store_toggleft_video_4_arg_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [paywallPage4aVideo, paywallPage4bVideo],
    keys: ['store_toggleft_video_4_arg_landscape'],
    orientation: 'landscape',
  },
}
//MAPPING DE TEMPLATE ( plusieurs templates)
export const pickerPortraitTemplates: Record<string, ITemplateConfig> = {
  onboarding_pickerft_activated_img_3_arg_3_market_slides_paywall_portrait: {
    component: PickerPortraitTemplate,
    config: [marketingPage1, marketingPage2, marketingPage3, pickerPaywallPage4a, pickerPaywallPage4b], // /pages
    keys: ['onboarding_pickerft_activated_img_3_arg_3_market_slides_paywall_portrait'], //keys
    orientation: 'portrait',
  },
}

export const fullEmbeddedTemplates: Record<string, ITemplateConfig> = {
  full_embedded_ui_1_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [embeddedPage1],
    keys: ['full_embedded_ui_1_landscape'],
    orientation: 'landscape',
  },
  full_embedded_ui_1_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1],
    keys: ['full_embedded_ui_1_portrait'],
    orientation: 'portrait',
  },
  full_embedded_ui_2_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [embeddedPage1, embeddedPage2],
    keys: ['full_embedded_ui_2_landscape'],
    orientation: 'landscape',
  },
  full_embedded_ui_2_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1, embeddedPage2],
    keys: ['full_embedded_ui_2_portrait'],
    orientation: 'portrait',
  },
  full_embedded_ui_3_landscape: {
    component: OnBoardingLandscapeTemplate,
    config: [embeddedPage1, embeddedPage2, embeddedPage3],
    keys: ['full_embedded_ui_3_landscape'],
    orientation: 'landscape',
  },
  full_embedded_ui_3_portrait: {
    component: OnBoardingPortraitTemplate,
    config: [embeddedPage1, embeddedPage2, embeddedPage3],
    keys: ['full_embedded_ui_3_portrait'],
    orientation: 'portrait',
  },
}
